import { useQuery, UseQueryResult } from 'react-query';
import { useSelector } from 'react-redux';

import { ConfigKey, getEnvVariable } from '@legacy-modules/common/services/EnvironmentConfigurationService';
import { selectTokenId } from '@redux/auth.selectors';
import RestbestandResponse, { RestbestandResponseApiModel } from '../models/RestbestandResponse';

const baseHttpUrl = getEnvVariable(ConfigKey.HTTP_API_URL);

export default function useRestbestand(
  // DMT-741 org-aggregation (HADV parity): a single numeric orgId, or a list of org IDs when the
  // selected node resolves to multiple (parent + descendant) orgs whose stock should be merged.
  orgId?: number | number[] | null,
  datum?: string | null, // ISO yyyy-MM-dd, from the Dashboard's existing Datum filter or custom input
  enabled: boolean = true
): UseQueryResult<RestbestandResponse> {
  const tokenId = useSelector(selectTokenId);

  const orgIds = (Array.isArray(orgId) ? orgId : orgId != null ? [orgId] : []).filter((id) => !isNaN(id));

  const url = new URL(`${baseHttpUrl}/reports/restbestand`);
  orgIds.forEach((id) => url.searchParams.append('orgId', String(id)));
  if (datum != null && datum.trim() !== '') url.searchParams.set('datum', datum.trim());

  return useQuery<RestbestandResponseApiModel, unknown, RestbestandResponse>({
    queryKey: ['restbestand', orgIds, datum],
    queryFn: () =>
      fetch(url.toString(), {
        headers: { ...(tokenId ? { token: tokenId } : {}) },
      }).then((res) => {
        if (!res.ok) throw new Error(`Restbestand request failed with status ${res.status}`);
        return res.json();
      }),
    enabled: enabled && orgIds.length > 0 && Boolean(datum && datum.trim() !== ''),
    select: (data) => RestbestandResponse.fromJson(data),
  });
}
